import { LoggedOutHomeImage } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import {
  IMAGE_WRAPPER_CLASSNAME,
  MOBILE_BANNER_IMAGE_SIZE,
  TABLET_BANNER_IMAGE_SIZE,
  DESKTOP_BANNER_IMAGE_SIZE,
  XLARGE_BANNER_IMAGE_SIZE,
  XXLARGE_BANNER_IMAGE_SIZE,
} from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/homepage-v2-only/ForAnyRetailerBanner/__internal__/consts.css";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { cn } from "@faire/web/tools/cn";
import isChromatic from "chromatic/isChromatic";
import * as React from "react";

// eslint-disable-next-line import/no-unassigned-import
import "./forAnyRetailerBanner.tw.css";

export const ForAnyRetailerBannerAnimatedImages: React.FC<{
  imageList: string[];
}> = ({ imageList }) => {
  return (
    <div className={IMAGE_WRAPPER_CLASSNAME}>
      {imageList.map((image, index) => {
        const delayClassNames = cn(
          index === 1 ? "animate-delay-500" : "",
          index === 2 ? "animate-delay-1000" : "",
          index === 3 ? "animate-delay-1500" : "",
          index === 4 ? "animate-delay-2000" : "",
          index === 5 ? "animate-delay-2500" : ""
        );
        return (
          <div
            key={index}
            className={cn(
              "absolute inset-0",
              !isChromatic() ? cn("animate-fade-in-out", delayClassNames) : ""
            )}
            data-test-id={`for-any-retailer-banner-image-${index}`}
          >
            <LoggedOutHomeImage
              lazyLoad
              responsiveImage={{
                mobileAndAbove: IImage.build({ url: image }),
              }}
              optimizeImageOptions={{
                mobileAndAbove: {
                  width: MOBILE_BANNER_IMAGE_SIZE,
                  height: MOBILE_BANNER_IMAGE_SIZE,
                },
                tabletAndAbove: {
                  width: TABLET_BANNER_IMAGE_SIZE,
                  height: TABLET_BANNER_IMAGE_SIZE,
                },
                desktopAndAbove: {
                  width: DESKTOP_BANNER_IMAGE_SIZE,
                  height: DESKTOP_BANNER_IMAGE_SIZE,
                },
                xLargeAndAbove: {
                  width: XLARGE_BANNER_IMAGE_SIZE,
                  height: XLARGE_BANNER_IMAGE_SIZE,
                },
                xxLargeDesktop: {
                  width: XXLARGE_BANNER_IMAGE_SIZE,
                  height: XXLARGE_BANNER_IMAGE_SIZE,
                },
              }}
              className="h-full w-full overflow-hidden"
            />
          </div>
        );
      })}
    </div>
  );
};
